<div class="lc-root">

  <!-- Canvas partículas -->
  <canvas #lcCanvas class="lc-canvas"></canvas>

  <!-- Aurora blobs -->
  <div class="lc-aurora lc-aurora-1"></div>
  <div class="lc-aurora lc-aurora-2"></div>
  <div class="lc-aurora lc-aurora-3"></div>

  <!-- Líneas diagonales animadas -->
  <div class="lc-bg-lines"></div>

  <!-- Watermark decorativo -->
  <span class="lc-watermark">UNAH</span>

  <!-- Loading overlay -->
  <div *ngIf="(loginFacade.responseLoading$ | async)?.loading" class="lc-loading-overlay">
    <div class="lc-spinner-wrap">
      <div class="lc-comet"></div>
      <p class="lc-spinner-label">Verificando credenciales...</p>
    </div>
  </div>

  <!-- Card principal -->
  <div class="lc-card">

    <!-- Panel izquierdo: ilustración -->
    <div class="lc-left">
      <div class="lc-glow-circle"></div>

      <div class="lc-left-top">
        <span class="lc-chip">
          <span class="lc-chip-dot"></span>
          Sistema de Posgrado
        </span>
      </div>

      <div class="lc-illustration">
        <img src="../../assets/images/Opciones/undraw_design_notes_8dmv.svg"
             alt="Ilustración" draggable="false">
      </div>

      <div class="lc-left-bottom">
        <h2 class="lc-left-title">{{ textoLogin }}</h2>
        <p class="lc-left-sub">Universidad Nacional Autónoma de Honduras</p>
      </div>
    </div>

    <!-- Panel derecho: formulario -->
    <div class="lc-right">

      <!-- Barra degradado superior -->
      <div class="lc-accent-bar"></div>

      <div class="lc-right-inner">

        <img src="../../assets/images/logo/logo-unah.png" alt="UNAH" class="lc-logo">

        <div class="lc-heading">
          <h1 class="lc-title">{{ txtUser }}</h1>
          <p class="lc-subtitle">
            <mat-icon class="lc-info-icon">shield</mat-icon>
            Para acceder debes autenticarte
          </p>
        </div>

        <form ngNativeValidate [formGroup]="loginForms" (ngSubmit)="login()" class="lc-form">

          <mat-form-field appearance="outline" class="lc-field">
            <mat-label>Usuario</mat-label>
            <input matInput formControlName="usuario" autocomplete="off" required
              (keydown.enter)="$event.preventDefault()">
            <mat-icon matSuffix>alternate_email</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="lc-field">
            <mat-label>Contraseña</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'"
              formControlName="password" autocomplete="off" required>
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide">
              <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>

          <div class="lc-forgot">
            <span (click)="redirectToForgotPassword()">¿Olvidaste tu contraseña?</span>
          </div>

          <div class="lc-actions">
            <button mat-button type="button" class="lc-btn-back" (click)="volver()">
              <mat-icon>arrow_back_ios</mat-icon> Volver
            </button>
            <button mat-raised-button type="submit" class="lc-btn-submit"
              [disabled]="(loginFacade.responseLoading$ | async)?.loading">
              <ng-container *ngIf="!(loginFacade.responseLoading$ | async)?.loading; else lcLoadingTpl">
                Ingresar &nbsp;<mat-icon>east</mat-icon>
              </ng-container>
              <ng-template #lcLoadingTpl>
                <mat-spinner diameter="22" strokeWidth="3"></mat-spinner>
              </ng-template>
            </button>
          </div>

        </form>
      </div>

      <p class="lc-footer">UNAH &copy; {{ year }} &middot; Todos los derechos reservados</p>
    </div>

  </div>
</div>
